import { useEffect } from "react";
import { useGameStore } from "../state/useGameStore";

/** Keyboard + preference wiring outside the Canvas. */
export function InputBridge() {
  const setPrefs = useGameStore((s) => s.setPrefs);

  useEffect(() => {
    const apply = () => {
      setPrefs({
        reducedMotion: window.matchMedia("(prefers-reduced-motion: reduce)")
          .matches,
        coarsePointer: window.matchMedia("(pointer: coarse)").matches,
      });
    };
    apply();
    const motion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const coarse = window.matchMedia("(pointer: coarse)");
    motion.addEventListener("change", apply);
    coarse.addEventListener("change", apply);
    return () => {
      motion.removeEventListener("change", apply);
      coarse.removeEventListener("change", apply);
    };
  }, [setPrefs]);

  useEffect(() => {
    const onKey = (e) => {
      const tag = e.target?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA") return;

      const {
        phase,
        climaxActive,
        boostOfferActive,
        start,
        strike,
        dismissClimax,
        dismissBoostOffer,
        acceptBoost,
        toggleHeap,
        returnToPlay,
      } = useGameStore.getState();

      if (e.key === "Escape") {
        if (climaxActive) {
          dismissClimax();
          return;
        }
        if (boostOfferActive) {
          dismissBoostOffer();
          return;
        }
        if (phase === "heap") {
          returnToPlay();
          return;
        }
      }

      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        if (phase === "intro") {
          start();
          return;
        }
        if (climaxActive) {
          dismissClimax();
          return;
        }
        if (boostOfferActive) {
          if (e.key === "Enter") acceptBoost();
          else dismissBoostOffer();
          return;
        }
        if (phase === "play") {
          strike();
          return;
        }
      }

      if ((e.key === "m" || e.key === "M") && phase !== "intro") {
        toggleHeap();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return null;
}
